import dayjs from 'dayjs';
import { DateTimeFormat } from '../Constants';
var InsertionOrderBudgetFormModel = /** @class */ (function () {
    function InsertionOrderBudgetFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, insertionOrderId = _a.insertionOrderId, budget = _a.budget, startTime = _a.startTime, endTime = _a.endTime, latestRequest = _a.latestRequest;
        this.id = id;
        this.insertionOrderId = insertionOrderId;
        this.budget = budget;
        this.startTime = startTime;
        this.endTime = endTime;
        this.latestRequest = latestRequest;
        this.campaignBudgets = [];
    }
    InsertionOrderBudgetFormModel.assign = function (data) {
        return new InsertionOrderBudgetFormModel(data);
    };
    Object.defineProperty(InsertionOrderBudgetFormModel.prototype, "isApproved", {
        get: function () {
            return this.id != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InsertionOrderBudgetFormModel.prototype, "isWaiting", {
        get: function () {
            return this.latestRequest.requestStatus == 'waiting';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InsertionOrderBudgetFormModel.prototype, "summary", {
        get: function () {
            var _a = this.isApproved
                ? this
                : this.latestRequest, budget = _a.budget, startTime = _a.startTime, endTime = _a.endTime;
            return {
                budget: budget,
                startTime: startTime,
                endTime: endTime,
                requestStatus: this.latestRequest.requestStatus,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InsertionOrderBudgetFormModel.prototype, "canEditCampaignBudgets", {
        get: function () {
            /**
             * 以下が編集可
             * 現在日付が案件の終了日を過ぎていない
             * かつ
             * 承認済みの予算（※変更申請中はダメ）
             * 初回申請が却下された予算
             * 初回申請が申請中の予算
             */
            return (dayjs().isBefore(dayjs(this.summary.endTime).endOf('day')) &&
                ((this.isApproved && this.summary.requestStatus !== 'waiting') ||
                    (!this.isApproved &&
                        ['rejected', 'waiting'].includes(this.summary.requestStatus))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InsertionOrderBudgetFormModel.prototype, "startTimeSelectable", {
        get: function () {
            var today = dayjs().startOf('hour');
            return today.isBefore(dayjs(this.summary.startTime))
                ? this.summary.startTime
                : today.format(DateTimeFormat);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InsertionOrderBudgetFormModel.prototype, "startEndSelectable", {
        get: function () {
            var today = dayjs().startOf('hour');
            return today.isBefore(dayjs(this.summary.endTime))
                ? this.summary.endTime
                : today.endOf('hour').format(DateTimeFormat);
        },
        enumerable: false,
        configurable: true
    });
    return InsertionOrderBudgetFormModel;
}());
export { InsertionOrderBudgetFormModel };
